"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOVE_PER_MODULE = exports.GET_PER_FINANCIAL_BODIES = exports.UPDATE_EMPLOYEE_INFORMATION = exports.UPDATE_REVIEWER_DETAILS = exports.MUTATE_AUDIT_REVIEW_DECISION = exports.UPDATE_PER_WITHDRAW = exports.MUTATE_UPDATE_SUPERVISOR_FEEDBACK = exports.MUTATE_EXAM_CREDIT_FROM_EPA = exports.MUTATE_EPA_STATUS_AND_COMMENTS = exports.MUTATE_UPDATE_ASSESSOR_FEEDBACK = exports.GET_SUPERVISOR_DASHBOARD = exports.MUTATE_SAVE_PER_RECORDS = exports.QUERY_PER_RECORD = void 0;
exports.QUERY_PER_RECORD = `
{
  getPERRecords
}
`;
exports.MUTATE_SAVE_PER_RECORDS = `
  mutation savePERRecords($perRecord: PERRecordPayload) {
    savePERRecords(perRecord: $perRecord)
  }
`;
exports.GET_SUPERVISOR_DASHBOARD = `
{
  getReviewerDashboardItem
}
`;
exports.MUTATE_UPDATE_ASSESSOR_FEEDBACK = `
  mutation saveAssessorPERFeedback($feedbackDetails: practicalExperienceAssessorFeedback) {
    saveAssessorPERFeedback(feedbackDetails: $feedbackDetails)
  }
`;
exports.MUTATE_EPA_STATUS_AND_COMMENTS = `
  mutation updateEPAStatusAndComments($epaDetails: epaStatusAndCommentsPayload, $epaMemberDetails: epaMemberDetails, $employerName: String, $status: String, $employerValidatorName: String, $attestationText: String, $recordType: String) {
    updateEPAStatusAndComments(epaDetails: $epaDetails, epaMemberDetails: $epaMemberDetails, employerName: $employerName, status: $status, employerValidatorName: $employerValidatorName, attestationText: $attestationText, recordType: $recordType)
  }
`;
exports.MUTATE_EXAM_CREDIT_FROM_EPA = `
  mutation updateExamCreditFromEpa($caseId: String) {
    updateExamCreditFromEpa(caseId: $caseId)
  }
`;
exports.MUTATE_UPDATE_SUPERVISOR_FEEDBACK = `
	mutation saveFeedback($feedbackDetails: practicalExperienceSupervisorFeedbackStatus) {
		saveFeedback(feedbackDetails: $feedbackDetails)
  }
`;
exports.UPDATE_PER_WITHDRAW = `
  mutation updatePerWithdrawn($perPortfolioId: String, $externalValidator: String, $perAuditKey: String) {
    updatePerWithdrawn(perPortfolioId: $perPortfolioId, externalValidator: $externalValidator, perAuditKey: $perAuditKey)
  }
`;
exports.MUTATE_AUDIT_REVIEW_DECISION = `
	mutation auditReviewDecision($auditReviewDecision: AuditReviewDecision) {
		auditReviewDecision(auditReviewDecision: $auditReviewDecision)
  }
`;
exports.UPDATE_REVIEWER_DETAILS = `
  mutation updateReviewerDetails($reviewerDetails: ReviewerDetails) {
    updateReviewerDetails(reviewerDetails: $reviewerDetails)
  }
`;
exports.UPDATE_EMPLOYEE_INFORMATION = `
  mutation updateEmployerInformation($employerInformation: EmployerInformation) {
    updateEmployerInformation(employerInformation: $employerInformation)
  }
`;
exports.GET_PER_FINANCIAL_BODIES = `
{
  getPERFinancialBodies
}
`;
exports.REMOVE_PER_MODULE = `
  mutation removePERModule($id: String, $recordType: String) {
    removePERModule(id: $id, recordType: $recordType)
  }
`;
//# sourceMappingURL=per-queries.js.map